import { render, staticRenderFns } from "./JoinedMultipleForm.vue?vue&type=template&id=7a224766&"
import script from "./JoinedMultipleForm.vue?vue&type=script&lang=js&"
export * from "./JoinedMultipleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports